<template>
  <b-modal size="xl" button-size="sm" v-model="showModal" :title="prefix + title" hide-footer @hidden="cancelar">
    <div>

      <b-button variant="primary" class="mt-3" @click="triggerFileInput">
        <b-icon icon="paperclip" font-scale="2" />
      </b-button>
      <b-form-file ref="fileInput" class="d-none" id="documentoInput"
        accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        @change="adicionarArquivo"></b-form-file>

      <b-table :items="files" :fields="fields" show-empty :busy="this.busy">

        <template #empty>
          <p>Nenhum registro encontrado</p>
        </template>


        <template #cell(name)="data">
          {{ data.item.name }}
        </template>

        <template #cell(tipoDocumento)="data">
          <lg-form-select v-model="data.item.tipoDocumento" :loadFunction="listDocumentos" labelFormGroupBind="Tipo:"
            label="descricao" class="fix-dropdown-inside-table" invalidFeedback="O tipo deve ser informado!" description="" />
        </template>


        <template #cell(actions)="data">
          <b-button id="remover-btn-dbt" variant="danger" @click="removeRow(data.index)" size="sm" pill>
            <b-icon icon="trash" />
            <b-tooltip target="remover-btn-dbt" title="Remover"></b-tooltip>
          </b-button>
        </template>
      </b-table>



      <div class="d-flex justify-content-center mt-3">
        <b-button id="salvar-btn-dre" type="submit" variant="success" style="height: 30px" pill size="sm" @click="submitData">
          <div>
            <b-icon icon="check-circle" />
          </div>
          <b-tooltip target="salvar-btn-dre" title="Salvar"></b-tooltip>
        </b-button>
        <b-button id="cancelar-btn-dre" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
          <div>
            <b-icon icon="x-circle" />
          </div>
          <b-tooltip target="cancelar-btn-dre" title="Cancelar"></b-tooltip>

        </b-button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import LgFormSelect from "@/core/components/Form/LgFormSelect.vue";
import ResourceService from "@/core/api/ResourceService";
import API from "../../api";
import { dataURItoBlob } from "@/utils/FileConverter";

export default {
  components: {
    LgFormSelect,
  },
  name: 'ModalDocumentosAdicionarVariosBemTerceiro',
  data() {
    return {
      title: 'Cadastro',
      files: [],
      showModal: true,
      fields: [
        { key: "name", label: "Nome" },
        { key: "tipoDocumento", label: "Tipo Documento", thStyle: { width: "30%" } },
        { key: "actions", label: "", tdClass:"w-1" },
      ],
    };
  },
  props: {
    prefix: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      required: true,
    },
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/documentobemterceiro`);
    this.$tipoDocumento = new ResourceService(`/api/tipo-documento`);
  },

  methods: {
    triggerFileInput() {
      document.getElementById("documentoInput").click();
    },
    async listDocumentos({ filter = "", page = 1 }) {
      return await this.$tipoDocumento.findAll({ filter, page, limit: 10 });
    },
    adicionarArquivo(event) {
      const files = event.target.files;

      for (let i = 0; i < files.length; i++) {
        const file = files[i];
        const reader = new FileReader();
        reader.onload = (e) => {
          const dataURI = e.target.result;
          const blob = dataURItoBlob(dataURI);

          this.files.push({
            name: file.name,
            file: blob,
            tipoDocumento: {},
          });
        };
        reader.readAsDataURL(file);
      }
    },
    async submitData() {
      const validateFile = (fileData, index) => {
        if (!fileData.file || fileData.file.length === 0) {
          this.$notify({
            type: "danger",
            message: `Selecione um arquivo no item ${index + 1}`,
          });
          return false;
        }
        if (!fileData.tipoDocumento || !fileData.tipoDocumento.id) {
          this.$notify({
            type: "danger",
            message: `Tipo de documento é obrigatório no item ${index + 1}`,
          });
          return false;
        }
        return true;
      };

      for (let i = 0; i < this.files.length; i++) {
        if (!validateFile(this.files[i], i)) {
          return;
        }
      }

      const formData = new FormData();
      this.files.forEach((fileData, index) => {
        formData.append(`files[${index}].file`, fileData.file);
        formData.append(`files[${index}].nome`, fileData.name);
        formData.append(`files[${index}].codBemTerceiro`, this.id);
        formData.append(
          `files[${index}].tipoDocumento`,
          fileData.tipoDocumento.id,
        );
      });

      this.busy = true;
      await API.post("/api/documentobemterceiro/multi-upload", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then(() => {
          this.busy = false;

          this.$notify({
            type: "success",
            message: `Documento adicionado com sucesso`,
          });
          this.cancelar();
        })
        .catch((error) => {
          this.busy = false;

          this.$notify({
            type: "danger",
            message: error.toString(),
          });
        });
    },
    removeRow(index) {
      this.files.splice(index, 1);
    },
    cancelar() {
      this.$emit("fechar");
    },
  },
};
</script>
